module.exports = __webpack_public_path__ + "img/spoiler-arrow.934894ad.svg";